module.exports = __webpack_public_path__ + "img/avatar5.9f5040f2.svg";